import DefaultInventoryTable from './InventoryTable.container';

export default DefaultInventoryTable;
